module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=0.25"},{"quantity":0.03,"color":"#91E3AD","label":"0.25 - 0.59"},{"quantity":0.06,"color":"#DEFFB0","label":"0.59 - 1.07"},{"quantity":0.01,"color":"#FFE68C","label":"1.07 - 1.82"},{"quantity":9,"color":"#FF9982","label":"1.82 - 2.77"},{"quantity":12,"color":"#FF4D30","label":"2.77 - 4.7"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/city_mme_1981_2016_lcr_70_wheat.json
// module id = Homk
// module chunks = 171